/**
 * Shared normalization/parsing helpers for questionnaire option text.
 *
 * Note: Some parts of the app want case-insensitive comparison but still need
 * the original label casing preserved for display. For that reason we expose:
 * - normalizeOptionText: trim only
 * - normalizeOptionTextLower: trim + lower-case (for comparisons)
 */

export const normalizeOptionText = (value: string | null | undefined) =>
  (value ?? "").trim()

export const normalizeOptionTextLower = (value: string | null | undefined) =>
  normalizeOptionText(value).toLowerCase()

export const safeParseStringArray = (value: string): string[] => {
  const trimmed = (value || "").trim()
  if (!trimmed) return []

  try {
    const parsed = JSON.parse(trimmed)
    if (Array.isArray(parsed)) {
      return parsed
        .filter((v): v is string => typeof v === "string")
        .map((v) => v)
    }
  } catch {
    // fallthrough
  }

  return [trimmed]
}
